import React, {useContext, useEffect, useState} from 'react';
import {Autocomplete, Card, DialogContent} from '@mui/material';
import {Field, useFormikContext} from 'formik';
import {TextField} from 'formik-mui';
import {dzongkhagList, gewogList, villageList} from '../../../services/PlaceServices';
import {DispatchContext} from '../../../store';

export default function AcquisitionEntryTwo({code}) {
  const {values, setFieldValue} = useFormikContext();
  const dispatch = useContext(DispatchContext);
  const [dzongkhags, setDzongkhags] = useState([]);
  const [gewogs, setGewogs] = useState([]);
  const [villages, setVillages] = useState([]);
  const noLoading = dispatch({type: 'IS_NOT_LOADING', payload: false});

  useEffect(() => {
    getDzongkhag();
  }, [noLoading, values?.dzongkhag_id]);

  const [selectedDzongkhag, setSelectedDzongkhag] = useState(null);

  useEffect(() => {
    const initialDzongkhag = dzongkhags?.find(
      option => option?.id === values?.dzongkhag_id
    );

    if (selectedDzongkhag) {
      getGewog(selectedDzongkhag?.id);
    }

    setSelectedDzongkhag(initialDzongkhag || null);
  }, [dzongkhags, selectedDzongkhag?.id]);

  const [selectedGewog, setSelectedGewog] = useState(null);

  useEffect(() => {
    const initialGewog = gewogs?.find(
      option => option?.id === values?.gewog_id
    );

    if (initialGewog) {
      setSelectedGewog(initialGewog);
      getVillages(initialGewog?.id);
    }
  }, [gewogs, selectedGewog?.id]);

  const findOptionById = (id) => {
    return dzongkhags?.find(option => option?.id === id);
  };

  useEffect(() => {
    const initialGewog = gewogs?.find(option => option?.id === values?.gewog_id);

    if (initialGewog) {
      setSelectedGewog(initialGewog);
    }
  }, [values?.gewog_id, gewogs]);

  const [selectedVillage, setSelectedVillage] = useState(null);

  useEffect(() => {
    const initialVillage = villages?.find(option => option?.name === values?.village_name);

    if (initialVillage) {
      setSelectedVillage(initialVillage);
    }
  }, [values?.village_name, villages]);

  const getDzongkhag = () => {
    dzongkhagList('get', null, {per_page: 20}).then(res => {
      dispatch({type: 'IS_NOT_LOADING', payload: false});
      setDzongkhags(res?.data);
    })
  }

  const getGewog = (id) => {
    gewogList('get', id, null, {per_page: 25}).then(res => {
    
      dispatch({type: 'IS_NOT_LOADING', payload: false});
      setGewogs(res?.data);
    })
  }

  const getVillages = (id) => {
    villageList('get', id).then(res => {
      dispatch({type: 'IS_NOT_LOADING', payload: false});
      setVillages(res?.data);
    })
  }

  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4}}>
        <Autocomplete
          id="combo-box-demo"
          options={dzongkhags}
          value={findOptionById(selectedDzongkhag?.id) || null}
          getOptionLabel={(option) => option?.name}
          size={'small'}
          className="dob mr-2 mt-3"
          onChange={(e, value) => {
            getGewog(value?.id || null);
            setSelectedDzongkhag(value);
            setFieldValue('dzongkhag_id', value?.id);
          }}
          renderInput={(params) => <Field component={TextField} {...params}
                                          label="Dzongkhag" sx={{mt: 1.5}}
                                          InputLabelProps={
                                            {style: {color: '#929191', fontSize: 14},
                                              shrink: true
                                            }}
                                          name="dzongkhag_id"/>}
        />
        <Autocomplete
          key={values?.gewog_id}
          id="combo-box-demo"
          options={gewogs}
          value={selectedGewog || null}
          getOptionLabel={(option) => option?.name}
          size={'small'}
          className="dob mr-2 mt-3"
          onChange={(e, value) => {
            getVillages(value?.id || null);
            setSelectedGewog(value);
            setFieldValue('gewog_id', value?.id || null);
          }}
          renderInput={(params) => <Field component={TextField} {...params}
                                          label="Gewog" sx={{mt: 1.5}}
                                          InputLabelProps={{
                                            style: {color: '#929191', fontSize: 14},
                                            shrink: true
                                          }}
                                          name="gewog_id"/>}
        />
        <Field component={TextField} variant={'outlined'} size={'small'} fullWidth label={'Chiwog'}
               name={`translations.${code}.chiwog`}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <Autocomplete
          id="combo-box-demo"
          options={villages}
          value={selectedVillage || null}
          getOptionLabel={(option) => option?.name}
          size={'small'}
          className="dob mr-2 mt-3"
          onChange={(e, value) => {
            getVillages(value?.id || null);
            setSelectedVillage(value);
            setFieldValue('village_id', value?.id || null);
          }}
          renderInput={(params) => <Field component={TextField} {...params}
                                          label="Village" sx={{mt: 1.5}}
                                          InputLabelProps={{
                                            style: {color: '#929191', fontSize: 14},
                                            shrink: true
                                          }}
                                          name="village_id"/>}
        />
      </Card>
    </div>
  );
}